import React from 'react';
import { GripVertical, FileText, Trash2 } from 'lucide-react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

/**
 * SortableSlide — extracted from PPTCustomization.jsx (Phase 8 refactor).
 * Drag-and-drop slide row in the outline sidebar.
 * Zero logic changes.
 */
const SortableSlide = ({ title, sectionId, activeTitleId, onSelect, handleDeleteTitle, isDraggingOverlay = false }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: title.id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.3 : 1,
        cursor: isDraggingOverlay ? 'grabbing' : 'pointer'
    };

    const slideName = title.text || 'Untitled Slide';
    const tooltipText = title.type === 'static' 
        ? `${slideName}\n(This is a static slide available for preview.)` 
        : slideName;

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`slide-row ${activeTitleId === title.id ? 'active' : ''} ${isDragging ? 'dragging' : ''} ${isDraggingOverlay ? 'overlay' : ''}`}
            onClick={() => onSelect(sectionId, title.id)}
            title={tooltipText}
        >
            <div className="slide-left-group">
                <div className="drag-handle" {...attributes} {...listeners}>
                    <GripVertical size={14} className="grip-icon" />
                </div>
                <div className="slide-icon">
                    <FileText size={14} />
                </div>
                <span className="slide-label">{slideName}</span>
            </div>
            {handleDeleteTitle && (
                <button
                    className="slide-delete-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteTitle(sectionId, title.id);
                    }}
                    title="Delete Slide"
                >
                    <Trash2 size={12} />
                </button>
            )}
        </div>
    );
};

export default SortableSlide;
